// Central business info shown in the top info bar, footer and contact surfaces.
export const SITE_INFO = {
  kvk: "95001751",
  phone: "+31 970 102 50680",
  phoneTel: "+3197010250680",
  outboundCallerId: "085 401 8951",
  email: "tp.agency@outlook.com",
};

// Official client logos only — add new entries as { name, src } when supplied.
export const CLIENT_LOGOS = [
  { name: "Trevi's", src: "/logos/trevis.png" },
];
